import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./contexts/CartContext";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import CheckoutPage from "./pages/CheckoutPage";
import ContactPage from "./pages/ContactPage";
import WarrantyPage from "./pages/WarrantyPage";
import ReturnsPage from "./pages/ReturnsPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOrdersPage from "./pages/admin/AdminOrdersPage";
import AdminMessagesPage from "./pages/admin/AdminMessagesPage";
import AdminCustomRequestsPage from "./pages/admin/AdminCustomRequestsPage";

function App() {
  return (
    <AdminAuthProvider>
      <CartProvider>
        <div className="App min-h-screen bg-[#050505]">
          <BrowserRouter>
            <Routes>
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="orders" element={<AdminOrdersPage />} />
                <Route path="messages" element={<AdminMessagesPage />} />
                <Route path="custom-requests" element={<AdminCustomRequestsPage />} />
              </Route>
              
              {/* Public Routes */}
              <Route path="/*" element={
                <>
                  <Header />
                  <main>
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/products" element={<ProductsPage />} />
                      <Route path="/checkout" element={<CheckoutPage />} />
                      <Route path="/contact" element={<ContactPage />} />
                      <Route path="/warranty" element={<WarrantyPage />} />
                      <Route path="/returns" element={<ReturnsPage />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </CartProvider>
    </AdminAuthProvider>
  );
}

export default App;
